export default "__VITE_ASSET__CNzO5A7A__"